export default function CtaSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[550px] flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Textured%20warm%20oatmeal%20colored%20linen%20fabric%20surface%20with%20scattered%20fashion%20magazine%20clippings%20and%20small%20leather%20goods%20arranged%20artfully%20soft%20diffused%20natural%20daylight%20from%20large%20window%20minimalist%20editorial%20interior%20scene%20cream%20and%20sand%20color%20palette%20peaceful%20atmosphere%20high%20end%20fashion%20photography%20style&width=1600&height=900&seq=cta-final-v2-2026&orientation=landscape"
          alt="Explore PandabuySpreadsheet"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 md:px-6 max-w-[700px] mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-white tracking-wide mb-4">
          READY TO EXPLORE?
        </h2>
        <p className="text-white/75 text-sm md:text-base max-w-[500px] mx-auto leading-relaxed mb-8">
          Discover thousands of curated PandabuySpreadsheet finds. Updated daily, community verified, and structured for effortless browsing.
        </p>

        {/* Main CTA */}
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm hover:bg-foreground-800 cursor-pointer whitespace-nowrap group"
        >
          <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-shopping-bag-line text-background-50 text-xs"></i>
          </span>
          GET PANDABUY SHEET
          <i className="ri-arrow-right-up-line text-background-400 group-hover:text-background-200 transition-colors"></i>
        </a>
      </div>
    </section>
  );
}